import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { getAspectRatio } from "../../../utils/aspect-ratio";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";

import type { PreviewProps } from "./types";
import type { FC } from "react";

export const LogoPreview: FC<PreviewProps> = (props) => {
  const [aspectRatio, setAspectRatio] = useState<number>();
  const { header } = props.data;
  const width = `${(header?.logo?.proportionOfMaxWidth ?? 1) * 100}%`;

  useEffect(() => {
    if (header?.logo?.src)
      void getAspectRatio(header?.logo?.src).then(setAspectRatio).catch(console.error);
  }, [header?.logo?.src]);

  return (
    <Box sx={{ width: "100%", textAlign: header?.logo?.align, p: 0, border: 0, marin: 0 }}>
      <ConditionalWrapper
        condition={props.badgeProps !== undefined}
        wrapper={(children) => (
          <HoverBadge badgeContent="Logo" name="logo" {...props.badgeProps}>
            {children}
          </HoverBadge>
        )}
      >
        <Button
          data-analytics-id="email-design-header-logo-preview"
          sx={{ width: "100%", minWidth: 1, p: 0 }}
          style={{
            justifyContent:
              header?.logo?.align && header?.logo?.align !== "center"
                ? `flex-${header.logo.align === "left" ? "start" : "end"}`
                : undefined,
          }}
        >
          {header?.logo?.src && (
            <img
              src={header?.logo?.src}
              alt={header?.logo?.alt ?? ""}
              width={width}
              style={{
                width,
                aspectRatio,
              }}
            />
          )}
          {!header?.logo?.src && "Your logo here"}
        </Button>
      </ConditionalWrapper>
    </Box>
  );
};
